export default class CollapsibleLight {
    constructor(element) {
        this.$document = $(document);
        this.$element = $(element);
        this.$control = this.$document.find(`[data-collapsible-control="${this.$element.data('collapsible-light')}"]`);

        this.hiddenClass = this.$element.data('collapsible-class') || 'hidden';
        this.activeClass = 'active';

        if (this.$element.data('collapsible-collapse')) {
            this.$element.removeClass(this.hiddenClass);
            this.$control.addClass(this.activeClass);
        }
    }

    toggle() {
        this.$element.toggleClass(this.hiddenClass);
        this.$control.toggleClass(this.activeClass);

        return false;
    }

    setListeners() {
        this.$control
            .off('click.toggle', '', $.proxy(this, 'toggle'))
            .on('click.toggle', $.proxy(this, 'toggle'));
    }

    init() {
        this.setListeners();
    }
}